import React from 'react';
import { NavLink } from 'react-router-dom';
import { X, Home, BookOpen, Briefcase, Brain, BarChart3, Users, Settings, GraduationCap, UserCheck } from 'lucide-react';
import useAuthStore from '../../store/authStore';
import useUserStore from '../../store/userStore';

const MobileSidebar = ({ isOpen, onClose }) => {
  // ✅ FIXED: Get user from authStore, not userStore
  const { user } = useAuthStore();
  const userType = user?.user_type || 'learner';

  const getNavigationItems = () => {
    switch (userType) {
      case 'learner':
        return [
          { name: 'Dashboard', href: '/learner', icon: Home },
          { name: 'Courses', href: '/learner/courses', icon: BookOpen },
          { name: 'Jobs', href: '/learner/jobs', icon: Briefcase },
          { name: 'Skills', href: '/learner/skills', icon: Brain },
        ];
      case 'trainer':
        return [
          { name: 'Dashboard', href: '/trainer', icon: Home },
          { name: 'My Courses', href: '/trainer/courses', icon: BookOpen },
          { name: 'Analytics', href: '/trainer/analytics', icon: BarChart3 },
          { name: 'Students', href: '/trainer/students', icon: Users },
        ];
      case 'policymaker':
        return [
          { name: 'Dashboard', href: '/policymaker', icon: Home },
          { name: 'Analytics', href: '/policymaker/analytics', icon: BarChart3 },
          { name: 'Skills Gap', href: '/policymaker/skills-gap', icon: Brain },
          { name: 'Reports', href: '/policymaker/reports', icon: BarChart3 },
        ];
      default:
        return [];
    }
  };

  const commonItems = [
    { name: 'Profile', href: '/profile', icon: Settings },
  ];

  const navigationItems = [...getNavigationItems(), ...commonItems];

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 z-40 lg:hidden">
        <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={onClose} />
      </div>

      {/* Sidebar */}
      <div className="relative flex-1 flex flex-col max-w-xs w-full bg-white z-50">
        <div className="absolute top-0 right-0 -mr-12 pt-2">
          <button
            type="button"
            className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
            onClick={onClose}
          >
            <X className="h-6 w-6 text-white" />
          </button>
        </div>

        <div className="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0 px-4">
            <div className="flex items-center">
              <div className="h-8 w-8 bg-gradient-to-r from-primary-600 to-secondary-600 rounded-lg flex items-center justify-center">
                <GraduationCap className="h-5 w-5 text-white" />
              </div>
              <div className="ml-3">
                <h1 className="text-xl font-bold text-gray-900">SkillMarg</h1>
                <p className="text-xs text-gray-500">AI-Powered Learning</p>
              </div>
            </div>
          </div>

          {/* User info */}
          <div className="mt-6 px-4">
            <div className="flex items-center">
              <div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center">
                <UserCheck className="h-6 w-6 text-primary-600" />
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-700">
                  {user?.first_name} {user?.last_name}
                </p>
                <p className="text-xs text-gray-500 capitalize">
                  {userType}
                </p>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <nav className="mt-8 px-2 space-y-1">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              return (
                <NavLink
                  key={item.name}
                  to={item.href}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `group flex items-center px-2 py-2 text-base font-medium rounded-md transition-colors duration-200 ${
                      isActive
                        ? 'bg-primary-100 text-primary-900'
                        : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                    }`
                  }
                >
                  <Icon
                    className={`mr-4 h-6 w-6 flex-shrink-0 ${
                      window.location.pathname === item.href
                        ? 'text-primary-600'
                        : 'text-gray-400 group-hover:text-gray-500'
                    }`}
                  />
                  {item.name}
                </NavLink>
              );
            })}
          </nav>
        </div>
      </div>
    </>
  );
};

export default MobileSidebar;